import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import CircularProgress from '@mui/material/CircularProgress';
import ContentLayout from './ContentLayout';
import React, { useEffect, useState } from 'react';
import SurveyImage from './SurveyImage';
import Tree from './Tree';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { fetchData } from '../common/app/actions';
import { getText } from '../common/utils/helpers';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      homeContainerStyle: {
        width: '100%',
        minHeight: '100%',
        // flex: 1,
        display: 'flex',
        flexDirection: 'row',
      },
      surveyWrapperStyle: {
        width: '100%',
        maxWidth: `${C.LEFT_CONTENT_MAX_WIDTH}px`,
        // flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
      },
      imageStyle: {
        marginBottom: '30px',
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
        flex: 1,
      },
      titleStyle: {
        fontWeight: FONT_WEIGHT.bold,
        fontSize: '16px',
        fontFamily: FONTS.alegreya,
        color: COLORS.textGray,
        marginBottom: '20px',
        marginLeft: '10px',
      },
    })
);

const Home = (): JSX.Element => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lng = useSelector((state: any) => state.app.lng);
  const [items, setItems] = useState(null);

  const themesData = useSelector((state: any) => state.app.themesData);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchData(C.THEMES_DATA, { themes: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (themesData && !items) {
      const allSurveys = [];

      themesData.forEach((item) => {
        allSurveys.push(...item.pages);
      });

      const surveys = allSurveys.filter(
        (item) => item.content?.firstpage === 'true'
      );

      const sortedSurveys = surveys.sort(
        (a, b) =>
          parseInt(a.content.firstpagenr) - parseInt(b.content.firstpagenr)
      );

      setItems(sortedSurveys);
    }
  }, [themesData]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!themesData || !items) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  const getSurveyItem = (item, index) => {
    const onAdd = (event: React.SyntheticEvent) => {
      event.stopPropagation();
      event.preventDefault();

      const url = item.content.uri.replace('temas/', '/add/');
      navigate(url);
    };

    const onView = (event: React.SyntheticEvent) => {
      event.stopPropagation();
      event.preventDefault();

      const rawUri = event.currentTarget.getAttribute('data-uri');
      const uri = rawUri.replace('temas/', '/theme/');
      navigate(uri);
    };

    return (
      <SurveyImage
        data={item}
        imageClassName={classes.imageStyle}
        onAdd={onAdd}
        onView={onView}
        key={index}
      />
    );
  };

  return (
    <ContentLayout>
      <div className={classes.titleStyle}>{'ŠOBRĪD AKTUALIZĒTĀS ANKETAS:'}</div>
      <div className={classes.surveyWrapperStyle}>
        {items.map(getSurveyItem)}
      </div>
    </ContentLayout>
  );
};

export default Home;
